import {
    Component,
    ChangeDetectionStrategy,
    Input,
    Output,
    ViewChild,
    EventEmitter,
} from "@angular/core";

@Component({
    selector: "zbd-snippets",
    templateUrl: "snippets.component.html",
    styleUrls: ["snippets.component.css"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnippetsComponent {
    @Input() public snippets: string[];
    @ViewChild("dropdown") dropdown;

    @Output("on-select") onSnippet = new EventEmitter<string>();

    toggle() {
        const el = this.dropdown.nativeElement;
        if (el.style.display === "block") {
            el.style.display = "none";
        } else {
            el.style.display = "block";
        }
    }

    onSnippetClick = (snippet: string) => {
        this.onSnippet.emit(snippet);
    };
}
